import actions from '@ion/api/audit-logs/actions';
import { METATAGGER_AUDIT_COLORS } from 'ion-experimental/app/metatagger/auditActions';

export function actionColor(action) {
  return COLOR_CODING[action] ?? 'gray';
}

export const COLOR_CODING = {
  [actions.ajs_file_built]: 'orange',
  [actions.ajs_file_uploaded]: 'blue',
  [actions.auth_logged_in]: 'gray',
  [actions.auth_logged_out]: 'gray',
  [actions.consent_category_created]: 'blue',
  [actions.consent_category_deleted]: 'red',
  [actions.consent_category_updated]: 'purple',
  [actions.event_name_created]: 'blue',
  [actions.event_name_deleted]: 'red',
  [actions.event_name_updated]: 'purple',
  [actions.event_schema_created]: 'blue',
  [actions.event_schema_updated]: 'purple',
  [actions.event_schema_deleted]: 'red',
  [actions.integration_added_to_pipeline]: 'green',
  [actions.integration_created]: 'blue',
  [actions.integration_deleted]: 'red',
  [actions.integration_removed_from_pipeline]: 'red',
  [actions.integration_revision_created]: 'blue',
  [actions.integration_revision_disabled]: 'red',
  [actions.integration_revision_enabled]: 'green',
  [actions.integration_updated]: 'purple',
  [actions.pipeline_tag_added_to_pipeline]: 'green',
  [actions.pipeline_tag_created]: 'blue',
  [actions.pipeline_tag_deleted]: 'red',
  [actions.pipeline_tag_removed_from_pipeline]: 'red',
  [actions.pipeline_tag_updated]: 'purple',
  [actions.pipeline_created]: 'blue',
  [actions.pipeline_deleted]: 'red',
  [actions.pipeline_deployed]: 'green',
  [actions.pipeline_integration_updated]: 'purple',
  [actions.pipeline_updated]: 'purple',
  [actions.pipeline_variable_updated]: 'purple',
  [actions.sample_event_created]: 'blue',
  [actions.sample_event_updated]: 'purple',
  [actions.sample_event_deleted]: 'red',
  [actions.schema_created]: 'blue',
  [actions.schema_deleted]: 'red',
  [actions.schema_updated]: 'purple',
  [actions.schema_library_created]: 'blue',
  [actions.schema_library_updated]: 'purple',
  [actions.schema_library_deleted]: 'red',
  [actions.schema_library_published]: 'purple',
  [actions.schema_library_added_to_pipeline]: 'green',
  [actions.schema_library_removed_from_pipeline]: 'red',
  [actions.standalone_sync_file_built]: 'orange',
  [actions.user_deleted]: 'red',
  [actions.user_invited]: 'blue',
  [actions.user_role_edited]: 'purple',
  ...METATAGGER_AUDIT_COLORS,
};
